import { AnimatePresence } from 'framer-motion';
import * as motion from 'framer-motion/m';

/**
 * BannerAccordionPanel.
 */
export const BannerAccordionPanel = ({
  children,
  isOpen,
}: {
  children: JSX.Element;
  isOpen: boolean;
}) => (
  <AnimatePresence initial={false}>
    {isOpen && (
      <motion.section
        key="content"
        initial="collapsed"
        animate="open"
        exit="collapsed"
        variants={{
          open: { opacity: 1, height: 'auto' },
          collapsed: { opacity: 0, height: 0 },
        }}
      >
        <motion.div
          variants={{ collapsed: { scale: 0.8 }, open: { scale: 1 } }}
          transition={{ duration: 0.8 }}
          className="flex justify-center"
        >
          {children}
        </motion.div>
      </motion.section>
    )}
  </AnimatePresence>
);
